/**
 * @generated SignedSource<<16ce13feabf5f4db845b6c9d10cc6d42>>
 * @relayHash f661a471536197eacfae2d25a3e285cd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9cac708ff8084f4660f96262f38a977830d1b7882122a13dde5b37efa5f40794

import type { ConcreteRequest, Query } from 'relay-runtime';
export type codePlannerConfigurationQuery$variables = {
  cloudId: string;
  query: string;
};
export type codePlannerConfigurationQuery$data = {
  readonly jira: {
    readonly jiraProjectsByJql: {
      readonly edges: ReadonlyArray<{
        readonly cursor: string;
        readonly node: {
          readonly id: string;
          readonly key: string;
          readonly name: string;
          readonly webUrl: AGG$URL | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly endCursor: string | null | undefined;
        readonly startCursor: string | null | undefined;
      };
      readonly totalCount: number | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type codePlannerConfigurationQuery = {
  response: codePlannerConfigurationQuery$data;
  variables: codePlannerConfigurationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
          }
        ],
        "concreteType": "JiraProjectConnection",
        "kind": "LinkedField",
        "name": "jiraProjectsByJql",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "totalCount"
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "startCursor"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          },
          {
            "concreteType": "JiraProjectEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "webUrl"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "codePlannerConfigurationQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "codePlannerConfigurationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "9cac708ff8084f4660f96262f38a977830d1b7882122a13dde5b37efa5f40794",
    "metadata": {},
    "name": "codePlannerConfigurationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9bbe903cd497952194cc2c9a9d002222";

export default node;
